<script lang="ts">
  import { Button, Input, InputGroup } from "sveltestrap";
  import { cart} from "../../../../store";
  import { href } from "../../../../utils/Constant/Constant";
  import {getCartTotal} from "../../../../Data/Ecommerce/Cartdata"
  let setCart:any
  cart.subscribe((value)=>{
      setCart = value
  })

</script>
<tr>
    <td colspan="4">
        <InputGroup>
            <Input class="me-2" type="text" placeholder="Enter coupan code" />
            <Button color="primary" {href}>{'Apply'}</Button>
        </InputGroup>
    </td>
    <td class="total-amount">
        <h6 class="m-0 text-end">
            <span class="f-w-600">{'Total Price :'}</span>
        </h6>
    </td>
    <td><span>$ {getCartTotal(setCart)}</span></td>
</tr>
